import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getLeadSummary, getProspectSummary } from '@/data/client';
import { Icon } from '@/lib/icons';
import { IqName } from '@/components/IqName';
import { useMe } from '@/auth/useMe';
import { NAV } from './nav';

/* Static rail on desktop, off-canvas drawer on mobile (same chrome as tritonIQ).
   No account switcher: a clientIQ user belongs to exactly one workspace. */
export function Sidebar({ open = false, onClose }: { open?: boolean; onClose?: () => void }) {
  const { me } = useMe();
  // The inbox count is the one number worth a badge: leads nobody has acted on.
  const { data: summary } = useQuery({ queryKey: ['leadSummary'], queryFn: getLeadSummary, refetchInterval: 60_000 });
  // …and for reps, the cold calls due now (theirs and unassigned).
  const { data: calls } = useQuery({ queryKey: ['prospectSummary'], queryFn: getProspectSummary, refetchInterval: 5 * 60_000 });
  return (
    <>
      <div className={`dash-scrim ${open ? 'is-open' : ''}`} onClick={onClose} aria-hidden="true" />
      <aside className={`dash-side ${open ? 'is-open' : ''}`}>
        <div className="dash-side__logo">
          <img src="/triton-logo.png" alt="Triton" className="dash-side__logoimg" />
          <button className="dash-side__close" type="button" onClick={onClose} aria-label="Close menu">
            <Icon name="x" size={20} />
          </button>
        </div>

        <div className="dash-side__client" style={{ cursor: 'default' }}>
          <div>
            <strong><IqName text="clientIQ" /></strong>
            <span>{me?.workspace.name ?? ''}</span>
          </div>
        </div>

        <nav className="dash-side__nav">
          {NAV.map((n) => (
            <NavLink key={n.path} to={n.path} end={n.end} className={({ isActive }) => `dash-navitem ${isActive ? 'is-active' : ''}`}>
              <Icon name={n.icon} size={18} />
              <IqName text={n.label} />
              {n.path === '/leads' && !!summary?.newCount && <span className="dash-navitem__count">{summary.newCount}</span>}
              {n.path === '/prospecting' && !!calls?.due && <span className="dash-navitem__count">{calls.due}</span>}
            </NavLink>
          ))}
        </nav>

        {me?.isAdmin && (
          <div className="dash-side__foot">
            <NavLink to="/settings" className={({ isActive }) => `dash-navitem ${isActive ? 'is-active' : ''}`}>
              <Icon name="settings" size={18} />
              <span>Settings</span>
            </NavLink>
          </div>
        )}
      </aside>
    </>
  );
}
